import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {apiClient} from "../connection/BlinkApiClient";
import {field} from "../../stem-core/state/StoreField";
import {Money} from "../../stem-core/localization/Money";
import {BaseEnum, makeEnum} from "../../stem-core/state/BaseEnum";
import {formatPercent} from "../../stem-core/base/Formatting";
import {StemDate} from "../../stem-core/time/Date";
import {EditableObjectStatus} from "./misc/GenericEnums";
import {Merchant} from "./MerchantStore";


@makeEnum
export class SubscriptionDiscountScope extends BaseEnum {
    static ALL_OFFERS = {name: "All subscription"};
    static TARGETED_COVERAGES = {name: "Selected subscription tiers"};
    static TARGETED_OFFERS = {name: "Selected subscription plans"};
}

@makeEnum
export class SubscriptionDiscountApplyPolicy extends BaseEnum {
    static BEFORE_SHIPPING;
    static AFTER_SHIPPING;
}

@makeEnum
export class SubscriptionDiscountType extends BaseEnum {
    static DISCOUNT_PERCENT;
    static DISCOUNT_AMOUNT;
    static FIXED_PRICE;
}


@globalStore
export class SubscriptionDiscount extends BaseStore("SubscriptionDiscount") {
    // TODO: missing some fields here
    @field("Merchant") merchant: Merchant;
    @field(Date) deletedAt: StemDate;
    @field(SubscriptionDiscountScope) scope: SubscriptionDiscountScope;
    @field(Array) targetOfferIds: number[];
    @field(Array) targetCoverageIds: number[];
    @field(String) name: string;
    @field(String) code: string;
    @field(Date) startDate: StemDate;
    @field(Date) expireDate: StemDate;
    @field(SubscriptionDiscountApplyPolicy) applyPolicy: SubscriptionDiscountApplyPolicy;
    @field(Number) numCyclesDiscounted: number;
    @field(String) discountPercent: string; // TODO Need to support Decimal
    @field(Number) discountAmount: number;
    @field(Number) discountFixedPrice: number;

    declare endDate: StemDate;

    // TODO @cleanups deprecate
    getCode(): string {
        return this.code;
    }

    getDiscountValue(): string {
        if (this.discountPercent != null) {
            const numericalPercent = parseFloat(this.discountPercent);
            return `${formatPercent(numericalPercent)} off`;
        }
        const currency = this.merchant.getCurrency();
        if (this.discountAmount != null) {
            return `${new Money(this.discountAmount, currency)} off`;
        }
        return `Reduced to ${new Money(this.discountFixedPrice, currency)}`;
    }

    // TODO @branch deprecate
    getMerchant(): Merchant {
        return this.merchant;
    }

    getStatus(): EditableObjectStatus {
        if (this.deletedAt) {
            return EditableObjectStatus.INACTIVE;
        }
        const now = StemDate.now();
        if (this.startDate?.isAfter(now)) {
            return EditableObjectStatus.DRAFT;
        }
        if (this.endDate?.isBefore(now)) {
            return EditableObjectStatus.EXPIRED;
        }
        return EditableObjectStatus.ACTIVE;
    }

    isActive(): boolean {
        return this.getStatus() === EditableObjectStatus.ACTIVE;
    }
}


export async function apiMerchantCreateSubscriptionDiscount(request: any): Promise<SubscriptionDiscount> {
    const response = await apiClient.post("/merchant/create_subscription_discount", request);
    return SubscriptionDiscount.loadObject(response);
}

export async function apiMerchantEditSubscriptionDiscount(request: any): Promise<any> {
    return apiClient.post("/merchant/edit_subscription_discount", request);
}

export async function apiMerchantArchiveSubscriptionDiscount(request: any): Promise<any> {
    return apiClient.post("/merchant/archive_subscription_discount", request);
}
